import type { AuthForm } from './types'

const authFormQueryValues = {
  login: 'login',
  createAccount: 'register',
  resetPassword: 'password-forgotten',
} as const satisfies Record<AuthForm, string>

const legacyAuthFormQueryValues = new Map<string, AuthForm>([
  ['password-forgoten', 'resetPassword'],
])

const authForms = Object.keys(authFormQueryValues) as AuthForm[]

export function parseAuthForm(search: string): AuthForm {
  const view = new URLSearchParams(search).get('view')

  return authForms.find(form => authFormQueryValues[form] === view)
    ?? (view ? legacyAuthFormQueryValues.get(view) : undefined)
    ?? 'login'
}

export function getAuthFormQueryValue(form: AuthForm) {
  return authFormQueryValues[form]
}
